<script setup>
import axios from 'axios'
import HeartSvg from '@svg/new-heart.svg'

const props = defineProps({
    comment: Object,
})

const emit = defineEmits()

const like = () => {
    axios.post(`/comments/${props.comment.id}/likes`).then(() => {
        props.comment.user_flags.liked = true
        props.comment.like_count = props.comment.like_count + 1
    })
}

const unlike = () => {
    axios.delete(`/comments/${props.comment.id}/likes`).then(() => {
        props.comment.user_flags.liked = false
        props.comment.like_count = props.comment.like_count - 1
    })
}
</script>

<template>
    <component :is="$page.props.auth.user ? `button` : `div`" v-on:click="$page.props.auth.user ? (comment.user_flags.liked ? unlike() : like()) : null" class="flex items-center space-x-1" dusk="comment-like">
        <HeartSvg class="size-5" :class="{ 'text-[rgba(255,100,128,1)]': comment.user_flags.liked, 'text-[rgba(112,120,176,1)]': !comment.user_flags.liked }" />
        <span class="font-medium" :class="{ 'text-[rgba(255,100,128,1)]': comment.user_flags.liked, 'text-[rgba(112,120,176,1)]': !comment.user_flags.liked }">{{ comment.like_count }}</span>
    </component>
</template>
